// Module
var code = `<terceraLabel left="40"  top="20" height="13" text="{{.textAttemptLabel}}"/>
<terceraLabel left="180" top="20" height="13" text="{{.textAttempt}}"/>
<terceraLabel left="40"  top="50" height="13" text="{{.textStatusLabel}}"/>
<terceraLabel left="180" top="50" height="13" text="{{.textStatus}}"/>`;
// Exports
export default code;